<template>
  <section-page
    title="Notifications"
  >
    <app-loading-section
      :loading="isLoading"
      :count="form.settings.length"
      heading="Notification settings is not available"
    >
      <div class="mb-150">
        <p>Choose how you would like to be notified when the following events happen within Forefront.</p>
      </div>

      <div class="mb-150">
        <h3 class="notification_sound--heading">Notification Sound</h3>

        <div class="flex flex-wrap mt-25">
          <p class="notification_sound--description">When you have the web app open in a browser what sound would you
            like to have played when you receive a new notification?</p>

          <form-field-select
            class="notification_sound--select"
            v-model="form.settings.notification_sound"
            @change="playSound"
          >
            <option
              v-for="sound in ENUMS.NotificationSoundEnum"
              :key="sound.value"
              :value="sound.value"
            >{{ sound.label }}
            </option>
          </form-field-select>
        </div>
      </div>

      <p v-if="!hasEmailNotificationsIntegration || !hasTextNotificationsIntegration" class="upgrade_message"><strong>WARNING</strong> {{ upgradeMessage }} In order to receive notifications you'll need to <a @click="openBillingPortal">upgrade your account</a>.</p>

      <div class="notification_item">
        <p class="notification_item--label">When a lead is automatically created</p>
        <div class="notification_item--toggles">
          <b-switch v-model="form.settings.record_new_mobile_notification" size="is-small" expanded
                    :disabled="!hasEmail">Mobile
          </b-switch>
          <b-switch v-model="form.settings.record_new_sms_notification" size="is-small" expanded
                    :disabled="!hasText || !hasTextNotificationsIntegration">
            Text
          </b-switch>
          <b-switch v-model="form.settings.record_new_email_notification" size="is-small" expanded
                    :disabled="!hasEmail || !hasEmailNotificationsIntegration">Email
          </b-switch>
          <b-switch v-model="form.settings.record_new_database_notification" size="is-small" expanded
                    :disabled="!hasEmail">In Web App Notifications
          </b-switch>
        </div>
      </div>

      <div class="notification_item">
        <p class="notification_item--label">When Duplicate Lead is created for a user who dose not have access to the original Lead</p>
        <div class="notification_item--toggles">
          <b-switch v-model="form.settings.duplicate_property_user_cant_access_mobile_notification"  size="is-small" expanded :disabled="!hasEmail">Mobile</b-switch>
          <b-switch v-model="form.settings.duplicate_property_user_cant_access_sms_notification"  size="is-small" expanded :disabled="!hasText || !hasTextNotificationsIntegration">Text</b-switch>
          <b-switch v-model="form.settings.duplicate_property_user_cant_access_email_notification"  size="is-small" expanded :disabled="!hasEmail || !hasEmailNotificationsIntegration">Email</b-switch>
          <b-switch v-model="form.settings.duplicate_property_user_cant_access_database_notification"  size="is-small" expanded :disabled="!hasEmail">In Web App Notifications</b-switch>
        </div>
      </div>

      <div class="notification_item">
        <p class="notification_item--label">Text message received on existing leads you're assigned to</p>
        <div class="notification_item--toggles">
          <b-switch v-model="form.settings.new_text_mobile_notification" size="is-small" expanded :disabled="!hasEmail">
            Mobile
          </b-switch>
          <b-switch v-model="form.settings.new_text_sms_notification" size="is-small" expanded
                    :disabled="!hasText || !hasTextNotificationsIntegration">
            Text
          </b-switch>
          <b-switch v-model="form.settings.new_text_email_notification" size="is-small" expanded
                    :disabled="!hasEmail || !hasEmailNotificationsIntegration">Email
          </b-switch>
          <b-switch v-model="form.settings.new_text_database_notification" size="is-small" expanded
                    :disabled="!hasEmail">In Web App Notifications
          </b-switch>
        </div>
      </div>

      <div class="notification_item">
        <p class="notification_item--label">Email received on existing leads you're assigned to</p>
        <div class="notification_item--toggles">
          <b-switch v-model="form.settings.new_email_email_notification" size="is-small" expanded
                    :disabled="!hasEmail || !hasEmailNotificationsIntegration">Email
          </b-switch>
          <b-switch v-model="form.settings.new_email_database_notification" size="is-small" expanded
                    :disabled="!hasEmail">In Web App Notifications
          </b-switch>
        </div>
      </div>

      <div class="notification_item">
        <p class="notification_item--label">Email replied to your Email Integration</p>
        <div class="notification_item--toggles">
          <b-switch v-model="form.settings.email_replied_to_email_notification" size="is-small" expanded
                    :disabled="!hasEmail || !hasEmailNotificationsIntegration">Email
          </b-switch>
          <b-switch v-model="form.settings.email_replied_to_database_notification" size="is-small" expanded
                    :disabled="!hasEmail">In Web App Notifications
          </b-switch>
        </div>
      </div>

      <div class="notification_item">
        <p class="notification_item--label">Inbound call on existing leads you're assigned to</p>
        <div class="notification_item--toggles">
          <b-switch v-model="form.settings.new_call_mobile_notification" size="is-small" expanded :disabled="!hasEmail">
            Mobile
          </b-switch>
          <b-switch v-model="form.settings.new_call_sms_notification" size="is-small" expanded
                    :disabled="!hasText || !hasTextNotificationsIntegration">
            Text
          </b-switch>
          <b-switch v-model="form.settings.new_call_email_notification" size="is-small" expanded
                    :disabled="!hasEmail || !hasEmailNotificationsIntegration">Email
          </b-switch>
          <b-switch v-model="form.settings.new_call_database_notification" size="is-small" expanded
                    :disabled="!hasEmail">In Web App Notifications
          </b-switch>
        </div>
      </div>

      <div class="notification_item">
        <p class="notification_item--label">New inbound comm for lead In follow up you're assigned to</p>
        <div class="notification_item--toggles">
          <b-switch v-model="form.settings.inbound_follow_up_notification_mobile_notification" size="is-small" expanded
                    :disabled="!hasText">Mobile
          </b-switch>
          <b-switch v-model="form.settings.inbound_follow_up_notification_sms_notification" size="is-small" expanded
                    :disabled="!hasEmail || !hasTextNotificationsIntegration">Text
          </b-switch>
          <b-switch v-model="form.settings.inbound_follow_up_notification_email_notification" size="is-small" expanded
                    :disabled="!hasText || !hasEmailNotificationsIntegration">Email
          </b-switch>
          <b-switch v-model="form.settings.inbound_follow_up_notification_database_notification" size="is-small"
                    expanded :disabled="!hasEmail">In Web App Notifications
          </b-switch>
        </div>
      </div>

      <div class="notification_item">
        <p class="notification_item--label">You are mentioned in a note</p>
        <div class="notification_item--toggles">
          <b-switch v-model="form.settings.mention_mobile_notification" size="is-small" expanded :disabled="!hasText">
            Mobile
          </b-switch>
          <b-switch v-model="form.settings.mention_sms_notification" size="is-small" expanded
                    :disabled="!hasText || !hasTextNotificationsIntegration">
            Text
          </b-switch>
          <b-switch v-model="form.settings.mention_email_notification" size="is-small" expanded
                    :disabled="!hasEmail || !hasEmailNotificationsIntegration">Email
          </b-switch>
          <b-switch v-model="form.settings.mention_database_notification" size="is-small" expanded
                    :disabled="!hasEmail">In Web App Notifications
          </b-switch>
        </div>
      </div>

      <div class="notification_item">
        <p class="notification_item--label">You are assigned to a task</p>
        <div class="notification_item--toggles">
          <b-switch v-model="form.settings.task_assigned_mobile_notification" size="is-small" expanded
                    :disabled="!hasText">Mobile
          </b-switch>
          <b-switch v-model="form.settings.task_assigned_sms_notification" size="is-small" expanded
                    :disabled="!hasText || !hasTextNotificationsIntegration">Text
          </b-switch>
          <b-switch v-model="form.settings.task_assigned_email_notification" size="is-small" expanded
                    :disabled="!hasEmail || !hasEmailNotificationsIntegration">Email
          </b-switch>
          <b-switch v-model="form.settings.task_assigned_database_notification" size="is-small" expanded
                    :disabled="!hasEmail">In Web App Notifications
          </b-switch>
        </div>
      </div>

      <div class="notification_item">
        <p class="notification_item--label">When an assigned task is overdue</p>
        <div class="notification_item--toggles">
          <b-switch v-model="form.settings.task_assigned_due_email_notification"  size="is-small" expanded :disabled="!hasEmail || !hasEmailNotificationsIntegration">Email</b-switch>
          <b-switch v-model="form.settings.task_assigned_due_database_notification"  size="is-small" expanded :disabled="!hasEmail">In Web App Notifications</b-switch>
        </div>
      </div>

      <div class="notification_item">
        <p class="notification_item--label">You are assigned to an appointment</p>
        <div class="notification_item--toggles">
          <b-switch v-model="form.settings.assigned_to_appointment_mobile_notification" size="is-small" expanded
                    :disabled="!hasText">Mobile
          </b-switch>
          <b-switch v-model="form.settings.assigned_to_appointment_sms_notification" size="is-small" expanded
                    :disabled="!hasText || !hasTextNotificationsIntegration">Text
          </b-switch>
          <b-switch v-model="form.settings.assigned_to_appointment_email_notification" size="is-small" expanded
                    :disabled="!hasEmail || !hasEmailNotificationsIntegration">Email
          </b-switch>
          <b-switch v-model="form.settings.assigned_to_appointment_database_notification" size="is-small" expanded
                    :disabled="!hasEmail">In Web App Notifications
          </b-switch>
        </div>
      </div>

      <div class="notification_item">
        <p class="notification_item--label">You are assigned to a lead</p>
        <div class="notification_item--toggles">
          <b-switch v-model="form.settings.assigned_to_record_mobile_notification" size="is-small" expanded
                    :disabled="!hasText">Mobile
          </b-switch>
          <b-switch v-model="form.settings.assigned_to_record_sms_notification" size="is-small" expanded
                    :disabled="!hasText || !hasTextNotificationsIntegration">Text
          </b-switch>
          <b-switch v-model="form.settings.assigned_to_record_email_notification" size="is-small" expanded
                    :disabled="!hasEmail || !hasEmailNotificationsIntegration">Email
          </b-switch>
          <b-switch v-model="form.settings.assigned_to_record_database_notification" size="is-small" expanded
                    :disabled="!hasEmail">In Web App Notifications
          </b-switch>
        </div>
      </div>

<!--      <div class="notification_item">-->
<!--        <p class="notification_item&#45;&#45;label">When a lead you are assigned to goes yellow</p>-->
<!--        <div class="notification_item&#45;&#45;toggles">-->
<!--          <b-switch v-model="form.settings.record_near_due_email_notification"  size="is-small" expanded :disabled="!hasEmail">Email</b-switch>-->
<!--          <b-switch v-model="form.settings.record_near_due_database_notification"  size="is-small" expanded-->
<!--                    :disabled="!hasEmail">In Web App Notifications</b-switch>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="notification_item">-->
<!--        <p class="notification_item&#45;&#45;label">When a lead you are assigned to goes red</p>-->
<!--        <div class="notification_item&#45;&#45;toggles">-->
<!--          <b-switch v-model="form.settings.record_past_due_email_notification"  size="is-small" expanded :disabled="!hasEmail">Email</b-switch>-->
<!--          <b-switch v-model="form.settings.record_past_due_database_notification"  size="is-small" expanded-->
<!--                    :disabled="!hasEmail">In Web App Notifications</b-switch>-->
<!--        </div>-->
<!--      </div>-->

      <div class="notification_item">
        <p class="notification_item--label">How you'll receive status automation notifications</p>
        <div class="notification_item--toggles">
          <b-switch v-model="form.settings.automation_mobile_notification" size="is-small" expanded
                    :disabled="!hasText">Mobile
          </b-switch>
          <b-switch v-model="form.settings.automation_sms_notification" size="is-small" expanded
                    :disabled="!hasText || !hasTextNotificationsIntegration">
            Text
          </b-switch>
          <b-switch v-model="form.settings.automation_email_notification" size="is-small" expanded
                    :disabled="!hasEmail || !hasEmailNotificationsIntegration">Email
          </b-switch>
          <b-switch v-model="form.settings.automation_database_notification" size="is-small" expanded
                    :disabled="!hasEmail">In Web App Notifications
          </b-switch>
        </div>
      </div>

      <div class="mt-100 flex flex-end">
        <button-default
          :loading="isSaving"
          :disabled="isSaving || (!hasText && !hasEmail)"
          @click="save"
        >
          Update
        </button-default>
      </div>

      <div class="mt-100 mb-200">
        <p class="notification_note"><strong>NOTE:</strong> You can download our apps from the <a
          href="https://apps.apple.com/us/app/forefront-crm/id1554894077#?platform=iphone" target="_blank">Apple App
          Store</a> or from the <a href="https://play.google.com/store/apps/details?id=com.forefrontcrm"
                                   target="_blank">Google Play Store</a></p>

        <p class="notification_note mt-50"><strong>NOTE:</strong> Mobile notification links will open the mobile app and
          text notifications will open the web app</p>
      </div>

      <div class="has-border-top my-150 pt-150">
        <span>These important notifications are to let you know that something is wrong. Therefore they are mandatorily set for you.</span>
      </div>

      <div class="notification_item">
        <p class="notification_item--label">When a follow up sequence gives a warning</p>
        <div class="notification_item--toggles">
          <b-switch :value="true" size="is-small" expanded :disabled="true">Email</b-switch>
          <b-switch :value="true" size="is-small" expanded :disabled="true">In Web App Notifications</b-switch>
        </div>
      </div>

      <div class="notification_item">
        <p class="notification_item--label">When an outbound status webhook fails</p>
        <div class="notification_item--toggles">
          <b-switch :value="true" size="is-small" expanded :disabled="true">Email</b-switch>
          <b-switch :value="true" size="is-small" expanded :disabled="true">In Web App Notifications</b-switch>
        </div>
      </div>

      <div class="notification_item">
        <p class="notification_item--label">When a webhook submission fails</p>
        <div class="notification_item--toggles">
          <b-switch :value="true" size="is-small" expanded :disabled="true">Email</b-switch>
          <!--          <b-switch :value="true" size="is-small" expanded :disabled="true">In Web App Notifications</b-switch>-->
        </div>
      </div>
    </app-loading-section>
  </section-page>
</template>

<script>
import {FormMixin} from "../../../forms/forms.mixin";
import {ENUMS} from "../../../services/enums";
import utils from "../../../services/utils";

export default {
  name: 'ProfileNotificationSettings',
  mixins: [FormMixin],
  data() {
    return {
      form: {
        id: this.$store.state.activeUser.id,
        settings: {}
      },
      isLoading: false,
      isSaving: false
    }
  },
  computed: {
    hasEmailNotificationsIntegration() {
      return this.$store.state.accounts.features.EmailNotifications;
    },
    hasTextNotificationsIntegration() {
      return this.$store.state.accounts.features.TextNotifications;
    },
    upgradeMessage() {
      const noEmail = !this.hasEmailNotificationsIntegration;
      const noText = !this.hasTextNotificationsIntegration;

      if(noEmail && noText) return "You don't have the Email & Text Notification Feature."
      if(noEmail) return "You don't have the Email Notification Feature."
      if(noText) return "You don't have the Text Notification Feature."
      return "You don't have this Feature."
    },
    hasText() {
      return this.$store.getters.account.has_text_notifications_feature;
    },
    hasEmail() {
      return this.$store.getters.account.has_email_notifications_feature;
    },
  },
  mounted() {
    this.initSettings();
  },
  methods: {
    initSettings() {
      this.isLoading = true;
      this.$api.users.getNotificationSettings(this.$store.state.activeUser.id)
        .then(res => {
          this.form.settings = res.data
        })
        .finally(() => {
          this.isLoading = false
        });
    },
    update() {
      return this.$api.users.updateNotificationSettings(this.form)
        .then((res) => {
          this.$buefy.toast.open({
            message: 'Your notification settings has been updated',
            type: 'is-success'
          });

          return res;
        });
    },
    playSound() {
      utils.playNotificationSound(this.form.settings.notification_sound)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";
@import "../../../styles/helpers/helpers";

.upgrade_message {
  margin-bottom: 1rem;
  padding: 8px 0;
  border-top: 1px solid $red;
  border-bottom: 1px solid $red;
  font-size: 1.125rem;
  line-height: 1.3;

  strong {
    color: $red;
  }
}

.notification_sound {

  &--heading {
    font-size: 1.25rem;
    color: $text-muted;
    font-weight: bold;
  }

  &--description {
    max-width: 440px;
    margin-right: 1rem;
    line-height: 1.3;
  }

  &--select {
    min-width: 240px;
    max-width: 300px;
    margin-top: 6px;
  }
}

.notification_item {
  margin-bottom: 1px;
  padding: 0.5rem 0;
  border-bottom: 1px solid $border;

  &--label {
    padding-bottom: 0.5rem;
  }

  &--toggles {
    padding: 0 1rem;
  }
}

.notification_note {
  font-size: 0.875rem;
  font-style: italic;
}

.columns {
  @extend .mb-100;
  @extend .mx-25;
  @extend .has-border-bottom;
}

.column {
  @extend .pr-25;
  @extend .pb-50;
  @extend .pl-25;
}

div.column {
  text-align: right;
}

p.column {
  flex: none;
}

.b-checkbox {
  @extend .mx-50;
}
</style>
